import {PriceRobotUrlInterface} from "./price-robot-url";

export class PriceRobotCompetitor {

    process_class: string = '';
    preference_class: string = '';
    name: string = '';
    url: string = '';
    id: number = 0;

    constructor(process_class: string = '', preference_class: string = '', name: string = '', url: string = '', id: number = 0) {
        this.process_class = process_class;
        this.preference_class = preference_class;
        this.name = name;
        this.url = url;
        this.id = id;
    }

    static _JSONProps: string[] = [
        'url',
        'id',
        'name',
        'preference_class',
        'process_class'
    ];

    static fromJSON(json: PriceRobotUrlInterface | string): PriceRobotCompetitor {
        if (json === null) {
            return new PriceRobotCompetitor();
        }

        if (typeof json === 'string') {
            return JSON.parse(json, PriceRobotCompetitor.reviver);
        } else {
            let task = new PriceRobotCompetitor();
            let extra = {};

            Object.keys(json).forEach((key, index) => {
                if (PriceRobotCompetitor._JSONProps.indexOf(key) !== -1) {
                    task[key] = json[key];
                }
            });

            return Object.assign(task, extra);
        }

    }

    static reviver(key: string, value: any): any {
        return key === "" ? PriceRobotCompetitor.fromJSON(value) : value;
    }

}

export interface PriceRobotCompetitorInterface extends PriceRobotCompetitor {
}
